import React from 'react';

export default function Footer() {
  return (
    <footer
      className="text-center mt-auto py-3"
      style={{ fontSize: '0.75rem', color: '#8892aa', borderTop: '1px solid #2a2d3a' }}
    >
      <span>
        Ein Projekt von{' '}
        <a href="https://mrroonix.com" target="_blank" rel="noreferrer" style={{ color: '#a0b4d0' }}>
          mRoonix
        </a>
        {' · '}
        <a
          href="https://mein.online-impressum.de/mrroonix/"
          target="_blank"
          rel="noreferrer"
          style={{ color: '#a0b4d0' }}
        >
          Impressum
        </a>
        {' · '}
        <a href="mailto:software@mrroonix.com" style={{ color: '#a0b4d0' }}>
          Feedback
        </a>
      </span>
    </footer>
  );
}
